import { QueovalBase, GQueovalDik } from '../global';

export class MediaModel {
  public Duplication: Duplication;
  public Media: ParamsMedia;
  public ListMedia: Array<ParamsMedia>;
  public ListMediaNames: Array<string>;
  public ListMediaIds: Array<number>;
  public ServerName: string;
  public FolderTypes: Array<string>;
  public ListMediasErrors: Array<ErrorParamsMedia>;
  public Filter: FilterMedia;
  public MaxSize: MaxSizesMedias;
  constructor() {
    this.Duplication = new Duplication();
    this.Media = new ParamsMedia;
    this.ListMedia = new Array<ParamsMedia>();
    this.ListMediasErrors = new Array<ErrorParamsMedia>();
    this.ListMediaNames = new Array<string>();
    this.ListMediaIds = new Array<number>();
    this.FolderTypes = new Array<string>();
    this.Filter = new FilterMedia;
    this.MaxSize = new MaxSizesMedias();
  }
}
export class Duplication {
  public ResellerParameters: DuplicationResellerParameters;
  public BuyerParameters: DuplicationBuyerParameters;
  public NewSourceDest: Array<GQueovalDik<string, string>> ;
  constructor() {
    this.ResellerParameters = new DuplicationResellerParameters();
    this.BuyerParameters = new DuplicationBuyerParameters();
    this.NewSourceDest = new Array<GQueovalDik<string, string>>();
  }
}
export class DuplicationResellerParameters {
  public ListSource: Array<string>;
  public FolderName: string;
  constructor(ListSource: Array<string> = new Array<string>(), FolderName: string = '') {
    this.ListSource = ListSource;
    this.FolderName = FolderName;

  }
}
export class DuplicationBuyerParameters {
  public DicSourceDest: Array<GQueovalDik<string, string>>;
  constructor(DicSourceDest: Array<GQueovalDik<string, string>> = new Array<GQueovalDik<string, string>>()) {
    this.DicSourceDest = DicSourceDest;

  }
}

export class MaxSizesMedias {
  public image: number;
  public document: number;
  public audio: number;
  public video: number;
}


export class ParamsMedia {
  public Ident: number;
  public FullName: string;
  public Name: string;
  public Path: string;
  public Extension: string;
  public Exist: boolean;
  public Type: string;
  public DateCreation: Date;
  public AutoPreviews: Array<string>;
  public PersonnalsPreviews: Array<string>;
  public NumberAutoPreviews: number;
  public NumberPersonnalsPreviews: number;
  public PersonalsPreviewsSizes: Array<number>;
  public size: number | null;
  constructor() {
    this.AutoPreviews = new Array<string>();
    this.PersonnalsPreviews = new Array<string>();
    this.NumberAutoPreviews = 0;
    this.NumberPersonnalsPreviews = 0;
  }
}

export class ErrorParamsMedia extends ParamsMedia {
  public From: string;
  constructor() {
    super();
    this.From = '';
  }
}

export class MediaQueovalModel extends QueovalBase {
  public MediaModel: MediaModel;
  constructor() {
    super();
    this.MediaModel = new MediaModel;
  }
}
export class MediaExtranetModel extends QueovalBase {
  public MediaModel: MediaModel;
  constructor() {
    super();
    this.MediaModel = new MediaModel;
  }
}
export class FilterMedia {
  public byType: FilterMediaByType;
  public byName: string;
  public numberByPage: number;
  public sorted: SortsMedia;
  constructor() {
    this.byType = new FilterMediaByType;
    this.byName = '';
    this.numberByPage = 10;
    this.sorted = new SortsMedia;
  }
}
export class SortsMedia {
  public byType: boolean;
  public byName: boolean;
  public byDate: boolean;
  public ascending: boolean;
  constructor() {
    this.byType = false;
    this.byName = false;
    this.byDate = true;
    this.ascending = false;
  }
}
export class FilterMediaByType {
  public video: boolean;
  public image: boolean;
  public audio: boolean;
  public document: boolean;
  constructor() {
    this.video = true;
    this.image = true;
    this.audio = true;
    this.document = true;
  }
}
